<template>
  <div class="detailWrap">
    <el-empty
      style="position: absolute; left: 0; right: 0; top: 0; bottom: 0; margin: auto"
      :image-size="160"
      description="暂无讨论"
      v-if="messageData.length <= 0"
    ></el-empty>
    <v-list lines="one">
      <v-list-item
        v-for="n in messageData"
        :key="n._id"
        subtitle="Lorem ipsum dolor sit amet consectetur adipisicing elit"
        style="border: 1px dashed #cfcfcf; padding: 10px; margin: 10px 0; border-radius: 5px"
      >
        <div class="messageWrap">
          <v-btn icon style="float: left; box-shadow: 4px 2px 5px 0 #989898">
            <v-avatar size="x-large" color="brown">
              <img
                :src="n.logImg ? n.logImg : require('@/assets/img/courseMessage.png')"
                style="width: 40px; height: 40px"
                alt=""
              />
            </v-avatar>
          </v-btn>
          <div style="width: auto; overflow: hidden">
            <p class="userName">
              <span class="fl-l userLog" style="margin-right: 20px">{{ n.nickName }}</span>
              <span class="fl-l userLog" style="color: #a0a0a0">{{
                dateFormat(n.created_at)
              }}</span>
              <!-- <span
                class="fl-r iconfont icon-dianzan_kuai"
                style="font-size: 13px; vertical-align: middle; color: #9a9797; cursor: pointer"
              >
                {{ n.top }}</span
              >
              <span
                class="fl-r iconfont icon-cai1"
                style="
                  font-size: 13px;
                  vertical-align: middle;
                  margin-right: 15px;
                  color: #9a9797;
                  cursor: pointer;
                "
              >
                {{ n.down }}</span
              > -->
            </p>
            <p class="userTime">
              <!-- <span class="fl-l">2023-12-22</span> <span class="fl-l">已上课10小时 </span> -->
              <span class="fl-l">
                <el-rate v-model="n.rate" :colors="colors" disabled text-color="#ff9900"
                  >>
                </el-rate></span
              >
            </p>

            <div style="padding: 5px; font-size: 14px; color: #a0a0a0; font-size: 14px">
              {{ n.message }}
            </div>
          </div>
        </div>
      </v-list-item>
    </v-list>
  </div>
</template>
    <script>
import moment from 'moment';
import { getdetailList, queryCourseThree, addMessage, queryMessage } from '@/api/simulation';
export default {
  // 话题讨论
  components: {},
  props: {
    routeData: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      value2: null,
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      commentList: [],
      messageData: [],
    };
  },
  watch: {
    routeData: {
      handler(news) {
        this.queryMessage(news);
      },
      deep: true,
    },
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    queryMessage(data) {
      let params = {
        courseId: data._id || '',
      };
      queryMessage(params).then(res => {
        this.messageData = res.data;
        // this.$emit('setMessageTitol',res.data.length)
      });
    },
    doSend() {},
    doChidSend() {},
  },
  mounted() {},
  computed: {},
  created() {
    if (this.routeData !== '{}') {
      this.queryMessage(this.routeData);
    }
  },
};
</script>
    <style scoped>
.detailWrap {
  width: 100%;
  min-height: 660px;
  height: auto;
  background: #fff;
  /* border: 1px solid #c8c8c8; */
  padding: 10px;
  position: relative;
}

.userName {
  width: auto;
  margin: 0px;
  overflow: hidden;
  padding: 10px 10px 0;
  color: #0f1419;
  /* float: right; */
}

.userTime {
  /* padding: 0 10px 0; */
  overflow: hidden;
  margin: 0px;
}
.userTime span {
  font-size: 13px;
  margin: 0 10px;
  color: #586470;
}
.messageWrap {
  width: 100%;
  height: auto;
}
.fl-l {
  float: left;
}
.fl-r {
  float: right;
}
.userLog {
  font-size: 14px;
}
/* .userLog > span:first-child {
  font-size: 14px;
} */
</style>
    